module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image14.0f205261.webp";